import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {

  async pesquisarCondicoesPagamento(api, parametros) {    
    parametros.operacao = 'pesquisarCondicoesPagamento' 

    let retorno = {};

    await api.santriGET('/rest/condicaoPagamento', parametros, 10, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined)
    })

    return retorno;
  },

  async buscarCondicaoPagamentoCompleta(api, parametros) {        
    parametros.operacao = 'buscarCondicaoPagamentoCompleta'

    let retorno = {};

    await api.santriGET('/rest/condicaoPagamento', parametros, 15, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined)
    })

    return retorno;
  }
  
}


// WEBPACK FOOTER //
// ./src/components/Rest/RCondicao.js